// Modules
import Head from 'next/head';

// Types
import { IPage } from 'src/common/types/CatalogType';

// Services
import catalogService from 'src/services/catalogService';

// Components
import LandingPage from 'src/components/templates/LandingPage';

// Brand content
import content from 'src/common/content';

// Hooks
import { useGeoLocation } from 'src/common/hooks/useGeoLocation';

interface IHome {
  catalogCover: IPage;
  pdfSrc: string;
}

const Home = ({ catalogCover, pdfSrc }: IHome) => {
  useGeoLocation();

  return (
    <>
      <Head>
        <link rel="canonical" href={`${content.urlBase}/`} />
      </Head>
      <LandingPage catalogCover={catalogCover} pdfSrc={pdfSrc} />
    </>
  );
};

export async function getStaticProps() {
  const res = await catalogService.getCatalog();

  return {
    props: {
      catalogCover: res.pages[0],
      pdfSrc: res.pdf,
    },
  };
}

export default Home;
